/* eslint-disable */
import dayjs from 'dayjs'
import actionTypes from '../constants/actionTypes'
import fetchHelper from '../utils/fetchHelper'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'
import * as SentryUtils from '../utils/sentryUtils'
import CONFIG from '../constants/config'
import { Modal, message } from 'antd'
import {
  setDetailPageLoading,
  setPhotos,
  setPhotosNum,
  setTotalFolderCount,
  setDefaultFolderCount,
  setCheckAll,
  clearCheckedPhotos
} from '../slices/folderSlice'
import {
  clearCheckedPhoto as clearCheckedPhotoAction,
  setCheckAll as setCheckAllPhotoAction,
  setCurrentViewPhoto as setCurrentViewPhotoAction
} from '../slices/photoSlice'

// 获取团队照片文件夹
export function fetchGroupFolders(data) {
  return (dispatch, getState) => {
    // dispatch({
    //   type: actionTypes.SET_LOADING,
    //   data: true
    // })

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/get',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((res) => {
        if (res.code === 200 && res.data.status === 0) {
          dispatch(setTotalFolderCount(res.data.totalFolderCount))
          dispatch(setDefaultFolderCount(res.data.defaultFolderCount))
          return res.data.data
        }
        return Promise.reject(null)
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
  }
}

// 获取团队照片文件夹子文件夹和照片数量
export function fetchFolderStatistic(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/statistic',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((res) => {
        if (res.code === 200) {
          return res.data
        }
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
  }
}

// 创建文件夹
export function createFolder(data) {
  return (dispatch, getState) => {
    // dispatch({
    //   type: actionTypes.SET_LOADING,
    //   data: true
    // })

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/create',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((res) => {
        if (res.code === 200) {
          return res.data
        }
        // dispatch(
        //   fetchGroupFolders({
        //     groupID: data.groupID
        //   })
        // )
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
      .finally(() => {
        // dispatch({
        //   type: actionTypes.SET_LOADING,
        //   data: false
        // })
      })
  }
}

// 目录上传：一次创建或复用完整的本地目录树。
export function ensureUploadFolderTree(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/folder/upload/tree/ensure',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((res) => {
        if (res.code === 200 && res.data?.status === 0) {
          return res.data
        }
        return Promise.reject(res.data)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}

// 取消新增
// export function cancelAddFolder() {
//   return (dispatch, getState) => {
//     const state = getState()
//     const folders = state.folder.get('groupFolders').toJS()

//     dispatch({
//       type: actionTypes.SET_FOLDERS,
//       data: folders.filter(({ folderID }) => !/^new_/.test(folderID))
//     })
//   }
// }

// 文件夹详情
export function getFolderInfo(data) {
  return (dispatch, getState) => {
    dispatch(setDetailPageLoading(true))

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/info',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((res) => {
        if (res.code === 200 && res.data.status === 0) {
          return res.data
        } else {
          return Promise.reject(null)
        }
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
      .finally(() => {
        dispatch(setDetailPageLoading(false))
      })
  }
}

// 更新文件夹
export function updateFolder(data) {
  return (dispatch, getState) => {
    dispatch(setDetailPageLoading(true))

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/update/name',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then(() => {
        message.success('修改成功')
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
      .finally(() => {
        dispatch(setDetailPageLoading(false))
      })
  }
}

// 删除文件夹
export function deleteFolder(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/delete',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then(() => {
        // return dispatch(
        //   fetchGroupFolders({
        //     groupID: data.groupID
        //   })
        // )
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 批量删除文件夹
export function batchDeleteFolders(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })

    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/batch/delete',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((res) => {
        // return dispatch(
        //   fetchGroupFolders({
        //     groupID: data.groupID
        //   })
        // )
        if (res.code === 200 && res.data.status === 0) {
          return res.data
        }
      })
      .catch((err) => {
        captureFetchException(err, config)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 下载
export function downloadFolder(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/sort/photo/download',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // 检查是否是新格式响应: { code, msg, data: { status, requestID } }
        if (result.code !== undefined && result.data !== undefined) {
          // 新格式响应，转换为旧格式供exceptionHelper处理
          const { code, data } = result
          const { status, requestID } = data || {}

          if (code === 200 && status === 0) {
            return Promise.resolve({
              ...data,
              payload: requestID
            })
          } else {
            // 构造旧格式的错误响应
            return exceptionHelper({
              code: code,
              msg: result.msg || '下载失败',
              data: {
                status: status || -1,
                msg: data?.msg || result.msg || '下载失败'
              }
            })
          }
        } else {
          // 旧格式响应，直接使用exceptionHelper
          return exceptionHelper(result)
        }
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() =>
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      )
  }
}

// 照片添加到文件夹
export function addPhotosToFolders(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/add',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((res) => {
        dispatch(clearCheckedPhotoAction())

        dispatch(setCheckAllPhotoAction(false))

        const limitFolderIDs = res.limitFolderIDs || []

        if (limitFolderIDs.length > 0) {
          Modal.warning({
            content: `添加失败，一个文件夹最多只能添加${CONFIG.folderConfig.folderMaxPhotosLimitStr}张照片`
          })
        } else {
          message.success('添加成功')
        }

        return res
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() =>
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      )
  }
}

// 上传照片添加到文件夹
export function uploadPhotosToFolders(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/add',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((res) => {
        // dispatch({
        //   type: actionTypes.CLEAR_CHECKED_PHOTO
        // })

        // dispatch({
        //   type: actionTypes.SET_CHECK_ALL,
        //   data: false
        // })

        const limitFolderIDs = res.limitFolderIDs || []

        // if (limitFolderIDs.length > 0) {
        //   Modal.warning({
        //     content: `添加失败，一个文件夹最多只能添加${CONFIG.folderConfig.folderMaxPhotosLimitStr}张照片`
        //   })
        // } else {
        //   message.success('添加成功')
        // }

        return res
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 获取指定文件夹下的照片
export function fetchFolderPhotos(data) {
  return (dispatch, getState) => {
    // dispatch({
    //   type: actionTypes.SET_LOADING,
    //   data: true
    // })
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/get',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((res) => {
        const state = getState()
        const photos = state.folder.photos
        const newPhotos = (res.photos || []).map((item) => {
          const photoID = Number(item.id)
          return {
            ...item,
            smallURL: item.smallurl,
            largeURL: item.largeurl,
            time: dayjs(item.time, CONFIG.minuteFormat).valueOf(),
            seq: photoID,
            photoID:
              Number.isSafeInteger(photoID) && photoID > 0 ? photoID : undefined
          }
        })

        dispatch(setPhotosNum(res.totalCount))

        if (data.page === 1) {
          dispatch(setPhotos(newPhotos))
        } else {
          dispatch(setPhotos([...photos, ...newPhotos]))
        }

        return res
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 把照片从文件夹中移除
export function removePhotosFromFolder(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/remove',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then(() => {
        const state = getState()
        const photos = state.folder.photos

        dispatch(
          setPhotos(
            photos.filter(
              (item) => !data.photoIDs.includes(item.seq.toString())
            )
          )
        )

        dispatch(clearCheckedPhotos())
        dispatch(setCheckAll(false))
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() =>
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      )
  }
}

export function fetchPhotoInfo(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/photo/info',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          groupID: data.groupID,
          photoID: data.photo.seq.toString()
        })
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((res) => {
        dispatch(setCurrentViewPhotoAction(data.photo))

        return res
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 修改照片所属的文件夹
export function modifyPhotoFolders(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/update',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .then((res) => {
        const limitFolderIDs = res.limitFolderIDs || []

        if (limitFolderIDs.length > 0) {
          Modal.warning({
            content: `添加失败，一个文件夹最多只能添加${CONFIG.folderConfig.folderMaxPhotosLimitStr}张照片`
          })
        } else {
          message.success('添加成功')
        }
      })
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() =>
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      )
  }
}

// 移动文件夹
export function cutFolders(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/cut',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return (
      fetchHelper(dispatch, getState, config)
        // .then((result) => exceptionHelper(result))
        .then((res) => {
          if (res.code === 200 && res.data.status === 0) {
            return res.data
          } else {
            message.error(res.data?.msg || '移动文件夹失败')
            return Promise.reject(null)
          }
        })
        .catch((err) => {
          SentryUtils.captureFetchException(err, config)
          return Promise.reject(null)
        })
        .finally(() =>
          dispatch({
            type: actionTypes.SET_LOADING,
            data: false
          })
        )
    )
  }
}

// 移动文件夹
export function cutPhotos(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/folder/photo/cut',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return (
      fetchHelper(dispatch, getState, config)
        // .then((result) => exceptionHelper(result))
        .then((res) => {
          if (res.code === 200 && res.data.status === 0) {
            return res.data
          } else {
            message.error(res.data?.msg || '移动照片失败')
            return Promise.reject(null)
          }
        })
        .catch((err) => {
          SentryUtils.captureFetchException(err, config)
          return Promise.reject(null)
        })
        .finally(() =>
          dispatch({
            type: actionTypes.SET_LOADING,
            data: false
          })
        )
    )
  }
}

// 拉取某文件夹内照片的可选水印标题列表，供「按标题筛选下载」弹窗使用。
// 入参 { userID, groupID, album: { type, id, filter } }（album 为后端容器描述符，type:4=分类文件夹）。
export function fetchFolderPhotoTitles(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/album/photos/titles',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        SentryUtils.captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() =>
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      )
  }
}
